<!-- 站点管理-->
<template>
  <div>
        <ctrl-box class="ctrl-box" ::data="{}">
            <template>
                <div class="xgroup">
                    <el-link :underline="false" @click="showQuery = !showQuery">
                        <div class="wrap" >
                            <i class="iconfont icon-sousuo font22" ></i>
                            <span class="txt" >{{msg('搜索')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="doAdd()" v-if="hasPermission('site:add')">
                        <div class="wrap" >
                            <i class="iconfont icon-add font22" ></i>
                            <span class="txt">{{msg('添加')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" @click="doEdit()" v-if="hasPermission('site:edit')">
                        <div class="wrap" >
                            <i class="iconfont icon-edit font22" ></i>
                            <span class="txt">{{msg('编辑')}}</span>
                        </div>            
                    </el-link>
                    <el-link :underline="false" type="danger" @click="doDelete()" v-if="hasPermission('site:delete')">
                        <div class="wrap" >
                            <i class="iconfont icon-delete font22"></i>
                            <span class="txt">{{msg('删除')}}</span>      
                        </div>
                    </el-link>
                </div>
            </template>
        </ctrl-box>
 
        <!--查询区域-->
        <transition name="el-zoom-in-top">
            <query-box :query="query" v-show="showQuery" labelWidth="80px">
                <template v-slot:default="scope">
                    <el-form-item :label="msg('站点名')">
                        <el-input v-model="scope.query.name" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('日期')">
                        <el-date-picker  v-model="scope.query.Date" type="daterange"  :range-separator="msg('至')" 
                            value-format="yyyy-MM-dd"
                            end-placeholder=""
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-row>
                        <el-button type="primary" icon="el-icon-search" @click="list" size="mini">{{msg('搜索')}}</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                    </el-row>
                </template>
            </query-box>
        </transition>

        <div class="table-wrap">
            <vxe-grid ref="dataTable" :height="docHeight" 
                export-config
                resizable border="full"
                show-overflow highlight-hover-row
                highlight-current-row highlight-hover-column highlight-current-column
                :data="sites"
                :columns="columns"
                @cell-click="checkRow"
            ></vxe-grid>

            <pagenator @page-change="handlerPageChange" :query="query" >
            </pagenator>
        </div>

        <el-dialog
            :title="editTitle"
            :visible.sync="editVisiable"
            :close-on-click-modal="false"
            width="40%">
            <el-form ref="form" :model="siteForm" label-width="80px">
                <el-form-item :label="msg('站点名称')">
                    <el-input v-model="siteForm.name" :placeholder="msg('请输入站点名称')">{{siteForm.name}}</el-input>
                </el-form-item>
                <el-form-item :label="msg('组织')">
                    <el-input v-model="siteForm.deptName">{{siteForm.deptName}}</el-input>
                </el-form-item>
                <el-form-item :label="msg('联系人')">
                    <el-input v-model="siteForm.fullname" :placeholder="msg('请输入联系人')">{{siteForm.fullname}}</el-input>
                </el-form-item>
                <el-form-item :label="msg('联系电话')">
                    <el-input v-model="siteForm.tel" :placeholder="msg('请输入联系电话')">{{siteForm.tel}}</el-input>
                </el-form-item>
                <el-form-item :label="msg('联系地址')">
                    <el-input v-model="siteForm.address" :placeholder="msg('请输入联系地址')">{{siteForm.address}}</el-input>
                </el-form-item>
                <el-form-item :label="msg('域名')">
                    <el-input v-model="siteForm.website" :placeholder="msg('请输入域名')">{{siteForm.website}}</el-input>
                </el-form-item>
                <el-form-item :label="msg('备案号')">
                    <el-input v-model="siteForm.beian" :placeholder="msg('请输入备案号')">{{siteForm.beian}}</el-input>
                </el-form-item>
                <el-form-item :label="msg('淘宝店铺')">
                    <el-input v-model="siteForm.taobao" :placeholder="msg('请输入淘宝店铺')">{{siteForm.taobao}}</el-input>
                </el-form-item>
                <el-form-item :label="msg('验货客服')">
                    <el-input v-model="siteForm.line" :placeholder="msg('请输入验货客服')">{{siteForm.line}}</el-input>
                </el-form-item>
            </el-form>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisiable = false">{{msg('取消')}}</el-button>
                <el-button type="primary" @click="doAddorEdit()">{{msg('确定')}}</el-button>
            </span>
        </el-dialog>

    </div>  
</template>
<script>

import Pagenator from "../../components/Pagination.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";

export default {
    name: 'site',
    components:{
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
    },
    mounted:function(){
        this.list();
    },
    data(){
        return {
            query:{
                length: 10,
                start: 0,
                pageIndex:1,
                pageTotal: 0,
            },
            showQuery: false,
            columns: [
                {type: 'checkbox', minWidth: 60},
                {field: 'id', title: this.msg('ID'), minWidth: 80, sortable: true},
                {field: 'name', title: this.msg('站点名'), minWidth: 130, sortable: true},
                {field: 'deptName', title: this.msg('所在组织'), minWidth: 130, sortable: true},
                {field: 'fullname', title: this.msg('联系人'), minWidth: 130, sortable: true},
                {field: 'tel', title: this.msg('联系电话'), minWidth: 130, sortable: true},
                {field: 'address', title: this.msg('联系地址'), minWidth: 130, sortable: true},
                {field: 'website', title: this.msg('域名'), minWidth: 130, sortable: true},
                {field: 'beian', title: this.msg('备案号'), minWidth: 130, sortable: true},
                {field: 'taobao', title: this.msg('淘宝店铺'), minWidth: 130, sortable: true},
                {field: 'line', title: this.msg('验货客服'), minWidth: 130, sortable: true},
                {field: 'createrName', title: this.msg('创建人'), minWidth: 120, sortable: true},
                {field: 'created', title: this.msg('创建时间'), minWidth:130, sortable: true}
            ],
            sites: [],
            editTitle:null,
            editVisiable: false,
            curr: null,
            siteForm:{
                name: null,
                dept_id: null,
                deptName: null,
                fullname: null,
                tel: null,
                address: null,
                website: null,
                beian: null,
                taobao: null,
                line: null,
            },
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
            return this.$store.state.isMinScreen;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
    },
    methods: {
        list(){
            var param = this.$kit.rebuildQuery(this.query);

            this.$axios.post(this.$kit.api.site.list, param)
                .then((result) => {
                    if(result.status){
                        this.sites = result.data.list;
                        this.query.pageTotal = result.data.total;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        reset(){
            this.$kit.clearQuery(this.query);
        },
        //点击行，选中行
        checkRow({row, $event}){
            //如果点击checkbox 则不处理
            if($event.target.className.indexOf("vxe-checkbox--icon")== -1){
                var table =  this.$refs.dataTable;
                table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))
            }
        },
        //分页数据发生改变，回调事件：info[0]: 每页显示的数量，info[1]: 起始页
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },
        doAdd(){
            this.siteForm = { 
                name: null,
                dept_id: null,
                deptName: null,
                fullname: null,
                tel: null,
                address: null,
                website: null,
                beian: null,
                taobao: null,
                line: null,
            };

            this.editTitle = this.msg("新增站点");
            this.editVisiable = true;
        },
        doEdit(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>1){
                this.$message(this.msg('只能编辑一条数据'));
                return;
            }

            this.siteForm  = selectes[0];

            this.editTitle = this.msg("编辑站点")+":"+this.siteForm.name;
            this.editVisiable = true;
        },
        doAddorEdit(){
            var url = null;
            if(this.siteForm.id==null){
                url = this.$kit.api.site.create;
            }else{
                url = this.$kit.api.site.update;
            }

            var _this = this;
            this.$axios.post(url, this.siteForm)
                .then(function(result){
                    if(result.status){
                        _this.$message(result.msg || (_this.siteForm.id==null? _this.msg("创建成功"): _this.msg('更新成功')));
                        if(result.status){
                            _this.editVisiable = false;
                        }
                    }else{
                        _this.$message(result.msg || (_this.siteForm.id==null? _this.msg('创建失败'):_this.msg('更新失败')));
                    }
                });
        },
        doExport(){
            this.$refs.dataTable.openExport({ isPrint: false })
        },
        doDelete(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            var _this = this;
            this.$confirm(this.fmt('确定要删除《%s》吗?', selectes.map(e => e.name).join(",")), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                _this.$axios.post(_this.$kit.api.site.delete+"?ids="+selectes.map(e => e.id).join(","))
                    .then((result) => {
                        _this.$message(result.msg || _this.msg('删除成功'));
                        _this.list(true);
                    });
            }).catch((err) => {
                // console.log(err);
            });
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
